module.exports = __webpack_public_path__ + "media/images/logo/logo-techzenith-f81ba5a81966da58d76531db6c5a5eb0.png";